module.exports = __webpack_public_path__ + "static/media/chevron-up.1fc18c7b.svg";